// extracted by mini-css-extract-plugin
export default {"image":"Carousel_image__9hIiq"};